// extracted by mini-css-extract-plugin
export default {"intlContainer":"V_ibRqeOMB8Lja_0mVxn__intlContainer___"};